import * as RandomId from '@lib/random-id'

export const ID = RandomId.make()
